import React from 'react';
import Icon from '../../../components/AppIcon';

const SecurityBadge = () => {
  return (
    <div className="mt-8 pt-6 border-t border-border">
      <div className="flex items-center justify-center space-x-6 text-xs text-muted-foreground">
        {/* HTTPS Security */}
        <div className="flex items-center space-x-1">
          <Icon name="Shield" size={14} className="text-success" />
          <span>HTTPS Sicher</span>
        </div>
        
        {/* GDPR Compliance */}
        <div className="flex items-center space-x-1">
          <Icon name="CheckCircle" size={14} className="text-success" />
          <span>DSGVO-konform</span>
        </div>
        
        {/* German Privacy */}
        <div className="flex items-center space-x-1">
          <Icon name="MapPin" size={14} className="text-success" />
          <span>Deutsche Server</span>
        </div>
      </div>
      
      <p className="text-center text-xs text-muted-foreground mt-3">
        Ihre Daten sind sicher und werden nach deutschen Datenschutzbestimmungen verarbeitet
      </p>
    </div>
  );
};

export default SecurityBadge;